import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "./style.css";
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../DoctorBite.js';
import PatientReviews from '../PatientReview.js';
import Counter from '../../NumCounter.js'
import GetInTouch from '../GetInTouch.js';
import FollowYt from '../FollowYt.js'
import Breadcrumb from '../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Tinnitus Diagnosis & Treatment in Delhi, India | ENT Specialist Cost, Doctor, Clinic </title>
            <meta name="description" content="Get expert tinnitus diagnosis and treatment in Delhi, India. Dr. Rajesh Bhardwaj offers advanced evaluation and relief for ringing ears, hearing issues, and related ENT problems." />
            <meta name="keywords" content=" tinnitus treatment in Delhi, ringing in ear care, audiological management, ENT tinnitus specialist" />
            <link rel="canonical" href="https://entdelhi.com/tinnitus-care-and-audiological-management/" />
            <meta property="og:title" content="Tinnitus Diagnosis & Treatment in Delhi, India | ENT Specialist Cost, Doctor, Clinic " />
            <meta property="og:description" content="Get expert tinnitus diagnosis and treatment in Delhi, India. Dr. Rajesh Bhardwaj offers advanced evaluation and relief for ringing ears, hearing issues, and related ENT problems." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
      <main>
        <Breadcrumb/>
        <Form />  
        <Counter/>
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         <Counter/>
         <GetInTouch/>
      </main>
    </div>
  )
}
